import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { FaAlignCenter, FaAlignLeft, FaAlignRight, FaAlignJustify } from "react-icons/fa";
import { connect } from "react-redux";
import { TldrEditorAction } from "../../../common/statelessView";

const TLDRTextAlign = (props) => {
  const { canvasRef, activeElement, t } = props;

  const editorFormat = canvasRef?.handler.textHandler.getStyle(
    activeElement.format
  );

  const [textAlign, setTextAlign] = useState(editorFormat?.textAlign);

  useEffect(() => {
    setTextAlign(activeElement?.format?.textAlign);
  }, [activeElement.format, canvasRef]);

  function onTextAlignButtonClick(alignValue) {
    props.canvasRef.handler.textHandler.textAlign(alignValue);
  }

  return (
    <>
      <TldrEditorAction
        action="left"
        icon={FaAlignLeft}
        title={t("fonts.left_align")}
        showHover={true}
        callback={onTextAlignButtonClick}
        active={textAlign === ""}
      />
      <TldrEditorAction
        action="center"
        icon={FaAlignCenter}
        title={t("fonts.center_align")}
        showHover={true}
        callback={onTextAlignButtonClick}
        active={textAlign === "center"}
      />
      <TldrEditorAction
        action="right"
        icon={FaAlignRight}
        title={t("fonts.right_align")}
        showHover={true}
        callback={onTextAlignButtonClick}
        active={textAlign === "right"}
      />
      <TldrEditorAction
        action="justify"
        icon={FaAlignJustify}
        title={t("fonts.justify")}
        showHover={true}
        callback={onTextAlignButtonClick}
        active={textAlign === "justify"}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  activeElement: state.editor.activeElement,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(TLDRTextAlign)
);
